import { render } from "./MachinesComponent.vue?vue&type=template&id=4063e2f7"
import script from "./MachinesComponent.vue?vue&type=script&lang=js"
export * from "./MachinesComponent.vue?vue&type=script&lang=js"

import "./MachinesComponent.vue?vue&type=style&index=0&id=4063e2f7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__